/* Built In Imports */
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Button, Link } from '@chakra-ui/react';
import { format } from 'date-fns';

/* Internal Imports */
/* Components */
import { isVisInViewport } from '@components/Utility/Shared/SharedService';
import { refineUrlDomain } from '@moms/Utility/utils';
import { mixPanel } from '@utils/Mixpanel';

/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const MomStickyButton = ({ section, region, language, csrData }) => {
  const stickyBtnData = section.find(el => el._modelApiKey === 'simple_button');
  // console.log(section, 'section');
  const [disableButton, setDisableButton] = useState(false);
  const [formattedDate, setFormattedDate] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const router = useRouter();
  const Mixpanel = mixPanel(router.asPath);

  useEffect(() => {
    window.addEventListener('scroll', listenToScroll);
    return () => window.removeEventListener('scroll', listenToScroll);
  }, []);

  useEffect(() => {
    // Check if programData is defined and has the active 'eventPgmId' property
    if (csrData && csrData[0]?.eventPgmId != null) {
      const date = new Date(csrData[0]?.date + 'T10:16:29.060Z');
      const newFormattedDate = format(date, 'MMM do yyyy');
      setFormattedDate(newFormattedDate);
      const disableButton = csrData[0]?.eventPgmId === undefined;
      setDisableButton(disableButton);
    }
  }, [setDisableButton, formattedDate]);

  const listenToScroll = () => {
    const footerDiv = document.getElementById('mom-form');
    const heightToHideFrom = window.innerHeight * 1.3;

    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    // console.log('winScroll', winScroll, heightToHideFrom);

    if (winScroll > heightToHideFrom) {
      const footerInViewPort = isVisInViewport(footerDiv);
      // console.log('winScroll', winScroll, registerDiv, inViewPort);
      // setIsVisible(true);
      if (
        document.documentElement.scrollTop >
          document.body.scrollHeight - window.innerHeight * 1.3 ||
        footerInViewPort
      ) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    } else {
      setIsVisible(false);
    }
  };

  return (
    isVisible &&
    !disableButton && (
      <Box
        position="fixed"
        top={{ base: 'unset', md: '50%' }}
        bottom={{ base: '2%', md: 'unset' }}
        zIndex="100"
        maxH={{ base: '65px', md: '265px' }}
        right={{ base: 'unset', md: '5px' }}
        left={{ base: '0', md: 'unset' }}
        width={{ base: '100%', md: 'auto' }}
      >
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-around'}
          flexDirection={{ base: 'row', md: 'column' }} // Set flexDirection to column for md
        >
          <Box>
            <Button
              bg="#EC1C2D"
              _hover={{ bg: '#EC1C2D' }}
              rounded="full"
              fontFamily="'Geist', sans-serif"
              py={{ base: '0px', md: '30px' }}
              border="none"
              borderRadius="150px"
              fontSize="18px"
              breakSpaces="break-spaces"
              w={{ base: 'auto', md: '200px' }}
              px="50px"
              fontWeight="400"
              onClick={() => {
                Mixpanel.track('mom_cta', {
                  cta: 'Sticky Button',
                  element: stickyBtnData?.buttonText,
                });
              }}
            >
              <NextLink
                href={
                  disableButton
                    ? '#'
                    : refineUrlDomain(stickyBtnData?.linkUrl, region, language)
                }
                passHref
                legacyBehavior
              >
                <Link
                  w="100%"
                  whiteSpace="break-spaces"
                  textDecor="none"
                  p="18px 0px 18px 0px"
                  _focus={{ outline: '0' }}
                  _hover={{ textDecoration: 'none' }}
                >
                  {stickyBtnData?.buttonText}
                </Link>
              </NextLink>
            </Button>
          </Box>
        </Box>
      </Box>
    )
  );
};

export default MomStickyButton;
